import PropTypes from 'prop-types';

const Menu2 = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            d="m22 4 .102.005a1 1 0 0 1 0 1.99L22 6H2a1 1 0 0 1 0-2zM22 11l.102.005a1 1 0 0 1 0 1.99L22 13H2a1 1 0 1 1 0-2zM22 18l.102.005a1 1 0 0 1 0 1.99L22 20H2a1 1 0 1 1 0-2z"
            fill={color}
        />
    </svg>
);

export default Menu2;

Menu2.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
